<template>
    <form method="post" action='/profile/form/password/change'>
        <slot name="csrf-token"></slot>
        <div class="form-modal">

            <label for="password">Vanha salasana</label>
            <input
                v-validate="'required|min:7'" data-vv-as="Vanha salasana" ref="password" type="password" name="password"
                id="password" placeholder="Kirjoita vanha salasanasi tähän" class="form-control" autocomplete="off">
            <span>{{ errors.first('password') }}</span>
            <br/>

            <label for="password_new">Uusi salasana</label>
            <input
                v-validate="'required|min:7'" data-vv-as="Uusi salasana" ref="password_new" type="password"
                name="password_new"
                id="password_new" placeholder="Kirjoita uusi salasanasi tähän" class="form-control" autocomplete="off">
            <span>{{ errors.first('password_new') }}</span>
            <input
                v-validate="'required|confirmed:password_new'" data-vv-as="Uuden salasanan vahvistus" type="password"
                name="password_new_confirmation" id="password_new_confirmation"
                placeholder="Kirjoita uusi salasana uudelleen"
                class="form-control mt-4" autocomplete="off">
            <span>{{ errors.first('password_new_confirmation') }}</span>
            <br/>
            <button :disabled="!isFormValid || errors.any()" type="submit" class="btn btn-primary mt-10">Vaihda salasana
            </button>
        </div>
    </form>

</template>

<script>
    export default {
        name: "ChangePasswordForm",

        computed: {
            isFormValid() {
                return Object.keys(this.fields).every(key => this.fields[key].valid);
            }
        }
    }
</script>

<style>

    input:valid {
        border-color: #39ad8f;
    }

    input:invalid {
        border-color: #a94442;
    }

    select:invalid {
        border-color: #a94442;
    }

    span.error-message {
        color: #a94442;
    }
</style>
